module.exports = __webpack_public_path__ + "fannie-mae-card-top-right@2x.1kgeQ7Mr.png";